<h2 mat-dialog-title>Upload Paper Script</h2>
<mat-dialog-content class="upload-dialog-content">
  <app-order-documents
    [userId]="data.payload.user_id"
    [orderId]="data.payload.order_id"
    [email]="data.payload.email"
    [uniqueOrderId]="data.payload.unique_order_id"
    [config]="orderDocumentsConfig"
    (documentCountChange)="handleDocumentCountChange($event)"
    [defaultTags]="defaultTags"
    addDocumentButtonLabel="Add Paper Script"
    [defaultDocumentTitle]="data.payload.file_name"
  ></app-order-documents>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
  @if (data?.actionButtonConfig?.show && data?.actionButtonConfig?.onClick) {
  <button
    mat-flat-button
    color="primary"
    (click)="data.actionButtonConfig.onClick(documentCount); close(true)"
    [disabled]="documentCount === 0"
  >
    {{ data.actionButtonConfig.label }}
  </button>
  }
</mat-dialog-actions>
